import styled from 'styled-components'

export const LoginStyles = styled.div`
  .login {
    padding: 100px 0 50px 0;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow-y: auto;
    background: url('${STATIC_BASE_URL}/static/webapp/images/signin-bg.png') no-repeat center center
      fixed;
    background-size: cover;
    color: var(--color-text);
  }

  @supports (-webkit-touch-callout: none) {
    .login input {
      font-size: 16px;
    }
  }

  .login .login-content {
    width: 320px;
    margin: auto;
    text-align: center;
  }

  .login .login-content .logo {
    height: 73px;
    margin-bottom: 50px;
  }

  .login .login-content .floating-form {
    padding: 45px 45px 20px;
    border-radius: 6px;
    position: relative;
    background: var(--color-surface);
    box-shadow: var(--shadow-1);
    color: var(--color-text);
  }

  .login .login-content .floating-form a {
    color: var(--secondary-color);
    font-size: 11px;
    text-align: right;
  }

  .login .login-content .floating-form a:hover {
    color: var(--secondary-color);
    text-decoration: underline;
  }

  .login .login-content .floating-form .privacy-police {
    color: var(--hint-color);
    font-size: 11px;
    margin-top: 24px;
    text-align: center;
    position: relative;
    z-index: 5;
    background: var(--color-surface);
  }

  .login .login-content .floating-form .privacy-police a {
    color: var(--secondary-color);
    font-size: inherit;
    text-align: inherit;
  }

  .login .login-content .floating-form .is-input {
    margin-bottom: 15px;
  }

  .login .login-content .floating-form .withValidation__container span {
    color: var(--hint-color);
  }

  .login .login-content .floating-form .field-error {
    color: var(--negative-color) !important;
  }

  .login .login-content .floating-form .is-button {
    width: 100%;
  }

  .login .login-content .floating-form .inline-button {
    color: var(--secondary-color);
    margin-top: 15px;
    padding: 10px;
    text-align: center;
    cursor: pointer;
    user-select: none;
  }

  .login .login-content .floating-form .separator-container {
    color: var(--sub-text-color);
    width: 100%;
    margin: 30px 0;
    border-bottom: 1px solid var(--color-border);
    line-height: 0.1em;
    text-align: center;
  }

  .login .login-content .floating-form .separator-container > span {
    font-size: 13px;
    padding: 0 15px;
    background: var(--color-surface);
  }

  .login .login-content .floating-form .alternative-auth {
    color: var(--color-text);
    font-size: 14px;
    width: 100%;
    margin-bottom: 12px;
    padding: 8px 12px;
    border: 1px solid var(--color-border);
    border-radius: 4px;
    display: block;
    background: var(--color-surface);
    text-align: left;
    cursor: pointer;
    user-select: none;
  }

  .login .login-content .floating-form .alternative-auth:hover {
    border-color: var(--secondary-color);
  }

  .login .login-content .floating-form .alternative-auth a {
    color: var(--color-text);
    display: block;
    text-decoration: none;
  }

  .login .login-content .floating-form .alternative-auth img {
    width: 16px;
    margin-right: 8px;
  }

  .login .login-content .floating-form .awards-container {
    margin-top: 32px;
  }

  .login .login-content .floating-form .awards-container img {
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.25));
  }

  .login .loader-overlap-container {
    background: color-mix(in srgb, var(--color-surface) 85%, transparent);
    z-index: 4;
  }

  .login .newPasswordLabel {
    font-size: 13px;
    margin: 1em 0;
    display: flex;
    justify-content: center;
  }
`
